module.exports = __webpack_public_path__ + "static/virtualsite-76c791a0180982fabb3e2897c16a3483.png";